<template lang="pug">
  b-container
    h4 Campañas
    // BUTTONS ROW
    b-form-row.bb-1.pb-2.justify-content-between.align-items-center.mb-3
      // PLATFORM BUTTONS
      b-col.mb-2.mb-md-0.w-md-50(sm="12", md="auto", lg="6")
        PlatformsRounded(hide-all-tab, :selected-platform="platform", @click="platform = $event" )
      // REDIRECT BUTTONS
      b-col(sm="12", md="auto")
        .d-flex.align-items-center.justify-content-md-arround.justify-content-end
          b-button#results-button(variant="outline-an", @click="saveMixpanel('Campaigns: Redirect to Results')", :to="{name: 'Campaigns Results'}" )
            .d-flex.align-items-center
              trending-up-icon.icon-sm.mr-1
              span Resultados
          .bl-1.border-dark.mx-2.pt-4(v-if="hasWhatsOfficial")
          b-button.pl-2.bl-1(variant="an", @click="saveMixpanel('Campaigns: Redirect to Whatsapp Templates')", :to="{name : 'Whatsapp Templates'}", v-if="hasWhatsOfficial")
            .d-flex.align-items-center
              file-icon.icon-sm.mr-1
              span Plantillas de Whatsapp
        b-tooltip(show, target="results-button") Aquí puedes consultar los resultados de las campañas
    // RUNNING CAMPAIGNS
    b-card(v-if="campaigns.length")
      .d-flex.justify-content-between.mb-2
        div Campañas en proceso de envío
        b-spinner(variant="primary", small, v-if="refreshing")
        refresh-cw-icon.icon-md.hover-primary.pointer(v-else, @click="getRunningCampaigns(true)")
      .mb-2(v-for="campaign in campaigns", :key="campaign.campaign_id" )
        .d-flex.justify-content-between.text-secondary.text-sm
          div
            span {{campaign.name}}
            span.mx-2 |
            span {{$moment(campaign.date).format('DD MMM YYYY - hh:mm A')}}
          div
            trash-icon.pointer.hover-danger.icon-sm.mr-2(@click="confirmDelete(campaign).then()", v-b-tooltip, title="Eliminar")
            x-circle-icon.pointer.hover-primary.icon-sm.text-secondary(@click="recoverCampaign(campaign)", v-b-tooltip, title="Cancelar y descargar resumen")
        b-progress
          b-progress-bar(v-if="campaign.status == 'scheduled'", value="100", label="Campaña programada", variant="secondary" )
          b-progress-bar(v-if="campaign.info !== 'Preparando envío' && campaign.status != 'scheduled'", value="100", :label="campaign.info", variant="secondary", animated )
          b-progress-bar.overflow-visible(v-else, :value="campaign.progress", :label="`Progreso: ${campaign.progress}% (${campaign.an_sent}/${campaign.totalContacts})`" )          
        div 
          b-badge.mr-1(variant="soft-success") Enviados {{campaign.sent}}
          b-badge.mr-1(v-if="campaign.platform === 'whatsapp_official'", variant="soft-info") Entregados {{campaign.delivered}}
          b-badge.mr-1(v-if="campaign.platform === 'whatsapp_official'", variant="soft-purple") Leídos {{campaign.read}}
          b-badge.mr-1(v-if="campaign.platform === 'whatsapp_official'", variant="soft-warning") Errores {{campaign.error}}
          b-badge.mr-1(v-if="campaign.platform === 'whatsapp_official'", variant="soft-warning") No subscritos {{campaign.notSubscribed}}
    // MESSAGE SELECTION
    b-overlay(:show="loading || sendingBroadcast", variant="transparent", spinner-variant="primary")
      b-form-row.mb-3
        // TEMPLATE || FLOW
        b-col.mb-3.mb-md-0(md="6")
          b-card.h-100.mb-0
            b-tabs(justified, small, v-model="tabIndex", nav-class="align-items-end", content-class="mt-2" )
              // SEND WHATSAPP TEMPLATE
              b-tab(title="Plantilla de Whatsapp", v-if="platformIsWhatsappOfficial")
                // CHATBOT SELECTION
                b-form-group.mb-1(label="Chatbot:", label-size="sm", invalid-feedback="Selecciona un chatbot", :state="validateState(modelId)")
                  k-select(:options="chatbots", placeholder="Selecciona el chatbot al cual se enviará el mensaje", v-model="modelId")
                // TEMPLATE SELECTION
                b-form-group(label="Plantilla:", label-size="sm", invalid-feedback="Selecciona una plantilla", :state="validateState(templateName)")
                  k-select(:options="message_templates", placeholder="Selecciona plantilla", v-model="templateName", @input="renderTemplate")
                // TEMPLATE VARIABLES
                // HEADER VARIABLES
                .mb-2(v-if="hasHeaderVars")
                  b-form-group(label="Variables de cabecera", label-size="sm" )
                    b-form-input(v-if="header.format === 'TEXT' && headerVar", size="sm", :placeholder="`Valor de {{${headerVar[0]}}}`", v-model="header_example_text", :state="validateState(header_example_text)")
                    b-input-group(size="sm", v-else-if="!!header.format && header.format !== 'TEXT'")
                      b-file(:placeholder="`Selecciona ${headerFileConfig[header.format].placeholder} de ejemplo`", size="sm", v-model="header_example_file", :disabled="uploading", :accept="headerFileConfig[header.format].accept", browse-text="Seleccionar", :state="validateState(header_example_file)")
                      b-input-group-append(v-if="header_example_file" )
                        b-button.b-0(variant="outline-danger", @click="header_example_file = null")
                          trash-icon.icon-sm
                // BODY VARIABLES
                div(v-if="bodyVars && bodyVars.length")
                  b-form-group(label="Variables de mensaje", label-size="sm" )
                    b-form-input.mb-2(v-for="(vars, index) in bodyVars", :key="index", :placeholder="`Valor para {{${vars}}}`", size="sm", v-model="body_example[index]", :state="validateState(body_example[index])")
              // SEND BLOCK
              b-tab(title="Bloque de flujo")
                // CHATBOT SELECTION
                b-form-group.mb-1(label="Chatbot:", label-size="sm", invalid-feedback="Selecciona un chatbot", :state="validateState(modelId)")
                  k-select(:options="chatbots", placeholder="Selecciona el chatbot al cual se enviará el mensaje", v-model="modelId")
                // BLOCK SELECTION
                b-form-group(label="Bloques:", label-size="sm", invalid-feedback="Selecciona un bloque", :state="validateState(blockId)")
                  k-select(:options="flows", placeholder="Seleccionar bloque", v-model="blockId", disable-branch-nodes)
        // MESSGE PREVIEW
        b-col(md="6")
          b-card.h-100.mb-0
            b-tabs.h-100(:value="tabIndex", nav-class="d-none", content-class="h-100" )
              // WHATSAPP PREVIEW
              b-tab.h-100(v-if="platformIsWhatsappOfficial")
                MessageTemplatePreview(v-bind="previewData")
              // FLOW PREVIEW
              b-tab.h-100
                .h-100.d-flex.flex-column(v-if="flow")
                  .test-sm.text-secondary Flujo:
                  .mb-2 {{flow.label}}
                  .test-sm.text-secondary Bloque:
                  .mb-2 {{blockName}}
                  .text-right.mt-auto
                    b-button(variant="link", @click="openBlock", :disabled="!blockId" ) Ir a Bloque
                div(v-else)
                  empty-message(message="Selecciona un bloque", )
    // USER SELECTION
    b-card(v-if="!loading")
      b-tabs(small, lazy)
        b-tab.my-2(title="Selección de archivo", v-if="platformIsWhatsappOfficial || platformIsSendgrid")
          b-row
            // BROADCAST CONFIGURATION
            b-col(md="6")
              // BROADCAST NAME
              b-form-group(label="Nombre de campaña", label-size="sm")
                b-form-input(size="sm", v-model="broadcastName", placeholder="Nombre de campaña", :state="validateState(broadcastName)")
              // SEND || SCHEDULE
              .text-center
                .d-flex.align-items-center
                  b-button.b-0(variant="an", block, @click="sendBroadcastFromFile", :disabled="sendingBroadcast", size="sm" )
                    b-spinner(small, v-if="sendingBroadcast")
                    div(v-else)
                      send-icon.icon-md.mr-1
                      span {{scheduleFormat ? 'Agendar' : 'Enviar'}}
                  .bl-1.border-dark.mx-2.pt-4
                  date-range-picker.w-100(v-bind="calendarProps", @update="scheduleDate = $event", )
                    template(v-slot:input="picker")
                      b-button(variant="outline-an", block, size="sm" )
                        span Programar
                        calendar-icon.icon-md.ml-1
                // SCHEDULE DATE
                .d-flex.align-items-center(v-if="scheduleFormat")
                  .text-secondary.mr-1 {{scheduleFormat}}
                  b-button.b-0(variant="outline-danger", size="sm", @click="scheduleDate = null")
                    trash-icon.icon-sm
            // FILE INPUT
            b-col(md="6")
              b-form-group.h-100#users-file(label-size="sm" )
                template(#label)
                  .d-flex.align-items-center.justify-content-between
                    div Subir archivo
                      info-icon.icon-sm.hover-primary.pointer.ml-1(@click="modalFileInfo = true")
                    //b-button.b-0.p-0(variant="outline-danger", size="sm", v-if="usersFile", @click="usersFile = null")
                      trash-icon.icon-md
                b-file.h-100(placeholder="Selecciona un archivo", drop-placeholder="Suelta el archivo aquí", v-model="usersFile", :disabled="uploading || sendingBroadcast", accept=".xls,.xlsx,.csv", :state="validateState(usersFile)")
                  template(#placeholder)
                    .text-center
                      file-plus-icon.icon-xl
                      .text-secondary.text-sm Da click aquí
                      //br o arrastra un archivo para subirlo
                  template(v-slot:file-name="{ names }")
                    .text-center
                      file-icon.icon-xl
                      .text-secondary.text-sm {{names[0]}}
        b-tab.mt-2(title="Selección usuarios")
          BroadcastUsers(v-bind="broadcastData", @click="sendBroadcast", :sending-broadcast="sendingBroadcast")
    // FILE INFO MODAL
    b-modal( v-model="modalFileInfo", hide-footer, header-class="b-0 pb-0", body-class="px-5 pb-5" )
      h4.text-center.mx-4.mb-3 Instrucciones para subir usuarios desde un archivo
      .mb-3
        .info-item
          b-avatar.side-icon(variant="light", size="4rem" )
            file-icon.text-primary.icon-xl
          .font-weight-bold Archivo.xlsx
          .text-sm(v-if='platformIsWhatsappOfficial') Sube un documento de hoja de cálculo (.xlsx) con una columna nombrada <span class="text-primary font-weight-bold"> phone </span> que contenga el número telefónico de los usuarios a quienes se les enviará la campaña. Este dato es obligatorio.
          .text-sm(v-if='platformIsSendgrid') Sube un documento de hoja de cálculo (.xlsx) con una columna nombrada <span class="text-primary font-weight-bold"> email </span> que contenga el correo electrónico de los usuarios a quienes se les enviará la campaña. Este dato es obligatorio.
        div(v-if='platformIsWhatsappOfficial')
          .info-item
            b-avatar.side-icon(variant="light", size="4rem" )
              plus-circle-icon.text-primary.icon-xl
            .font-weight-bold Prefijo del país
            .text-sm Deberás usar el número telefónico con el prefijo del país correspondiente. Por ejemplo, para un número de México el prefijo es +52 por lo que quedaría: 52180033230519.
          .info-item
            b-avatar.side-icon(variant="light", size="4rem" )
              phone-icon.text-primary.icon-xl
            .font-weight-bold Consulta un teléfono
            .text-sm
              div Usa el siguiente link para comprobar que un telefóno sea correcto: https://wa.me/NUMERO_TELEFONICO. Sustituye NÚMERO_TELEFÓNICO por el número, copia el enlace en tu navegador y si te dirige al chat, sí es correcto.
              div Por ejemplo:
                a(href="https://wa.me/5218003230519", target="blank") https://wa.me/5218003230519

      .font-weight-bold Importante
      .text-sm {{fullNameInfo}}
</template>

<script>
import MessageTemplatePreview from '@/components/MessageTemplatePreview'
import PlatformsRounded from '@/components/PlatformsRounded.vue'
import BroadcastUsers from "@/views/account/CampaignsUsers"
import Select from '@/components/Select'
import Days from '@/data/days'
import Months from '@/data/months'
import {UploadFile} from '@/helpers/upload-file'
import {RenderTemplate} from '@/helpers/templateView'
import {createNamespacedHelpers, mapActions} from 'vuex'
import mixpanel from '@/mixpanel';
import Download from 'downloadjs'

const platformController = createNamespacedHelpers('platform')
const templatesController = createNamespacedHelpers('message_template')
const flowController = createNamespacedHelpers('flow')
const broadcastController = createNamespacedHelpers('broadcast')

export default {
  name: "Campaigns",
  data () {
    const minDate = this.$moment().format()
    const dateRange = {startDate: this.$moment().format() }
    return {
      loading: false,
      missingData: false,
      uploading: false,
      sendingBroadcast: false,
      refreshing: false,
      modalFileInfo: false,
      modelId: null,
      templateName: null,
      selectedTemplate: null,
      blockId: null,
      usersFile: null,
      usersUrlFile: null,
      scheduleDate: null,
      tabIndex: 0,
      platform: '',
      broadcastName: '',
      //PREVIEW COMPONENTS
      headerFileConfig: {
        IMAGE: {accept: 'image/*', placeholder: 'imagen'},
        DOCUMENT: {accept: '.pdf', placeholder: 'documento'},
        VIDEO: {accept: '.mp4', placeholder: 'video'},
      },
      messageTemplate: {
        body: '',
        name: '',
        category: null,
        language: null
      },
      header: { format: null, text: '' },
      header_example_text: '',
      header_example_file: null,
      header_file: null,
      footer: '',
      buttons: [],
      body_example: [],
      regex: /(?<=\{\{)\d+?(?=}})/g,
      fullNameInfo: 'Puedes agregar otras columnas con nombres sin espacios para usarlas como información dentro del chatbot. Por ejemplo, la columna \'nombre_completo\' se usaría en los parámetros de la plantilla seleccionada con la variable: {{nombre_completo}}',
      calendarProps: {
        appendToBody: true,
        singleDatePicker: true,
        timePicker: true,
        showDropdowns: true,
        ranges: false,
        opens: 'center',
        minDate,
        dateRange,
        localeData: {
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          daysOfWeek: Days.daysShort,
          monthNames: Months.monthsShort,
          firstDay: 0
        }
      },
    }
  },
  computed: {
    ...platformController.mapState({
      platforms: state => state.platforms,
      chatbots: state => state.chatbots.map(el =>{
        el.id = el.model_id
        el.label = el.phone_number ? `${el.name} - ${el.phone_number}` : el.name
        return el
      })
    }),
    ...templatesController.mapState({
      message_templates: state => state.message_templates.filter(el => el.status === 'Aprobado').map(el => {
        el.id = el.label = el.name
        return el
      })
    }),
    ...flowController.mapState({
      flows: state => state.flows.map(el => {
        const { Blocks = [] } = el
        return {
          id: el.flow_id,
          label: el.name,
          children: Blocks.map(b => {
            return {
              id: b.block_id,
              label: b.name
            }
          })
        }
      }),
    }),
    ...broadcastController.mapState({
      campaigns: state => state.campaigns.map(el => {
        const { totalContacts, an_sent } = el
        const progress = (an_sent/totalContacts) * 100
        el.progress = progress.toFixed(0)
        return el
      })
    }),
    hasWhatsOfficial () {
      return this.platforms.some(el => el.name === 'whatsapp_official')
    },
    platformIsWhatsappOfficial () {
      return this.platform === 'whatsapp_official'
    },
    platformIsSendgrid () {
      return this.platform === 'sendgrid'
    },
    previewData () {
      if(!this.selectedTemplate) return {}
      return {
        header: this.header,
        header_example_text: this.header_example_text,
        header_example_file: this.header_example_file,
        body_message: this.messageTemplate.body,
        body_example: this.body_example,
        footer: this.footer,
        buttons: this.buttons
      }
    },
    headerVar () {
      return this.header.text.match(this.regex)
    },
    bodyVars () {
      if (this.messageTemplate && this.messageTemplate.body) {
        const match = this.messageTemplate.body.match(this.regex)
        return match ? match.filter((value, index, self) => self.indexOf(value) === index) : []
      }
      return []
    },
    hasHeaderVars () {
      return (this.header.format && this.header.format !== 'TEXT') || !!(this.header.format === 'TEXT' && this.headerVar)
    },
    scheduleFormat () {
      if(!this.scheduleDate) return  ''
      return `Campaña programada: ${this.$moment(this.scheduleDate.startDate).format('DD MMMM YYYY - HH:mm')}`
    },
    sourceSelected () {
      return !!(this.templateName || this.blockId)
    },
    broadcastData () {
      return {
        platform: this.platform,
        modelId: this.modelId
      }
    },
    flow () {
      return this.flows.find(el => {
        return el.children.find(({id}) => id === this.blockId)
      })
    },
    blockName () {
      if(!this.flow) return ''
      const block = this.flow.children.find(({id}) => id === this.blockId)
      return block ? block.label : ''
    },
  },
  methods: {
    ...mapActions([
      'platform/all',
      'platform/get',
      'flow/all',
      'message_template/all',
      'broadcast/campaigns',
      'broadcast/sendFromFile',
      'broadcast/destroy',
      'broadcast/schedule',
      'broadcast/send',
      'broadcast/recovery',
      'helpers/upload_file',
    ]),
    getPlatforms () {
      this.loading = true
      this['platform/all']({
        account_id: this.$route.params.account_id,
        callback: res => {
          this.loading = false
          if (res.error) return this.$message.error(res.error)

          if(this.platforms.length) {
            const whatsappOfi = this.platforms.find(el => el.name === 'whatsapp_official')

            if(!whatsappOfi) return this.platform = this.platforms[0].name

            this.platform = whatsappOfi.name
            this.$nextTick(() => {
              this.tabIndex = 0
            })
          }
        }
      })
    },
    async confirmDelete (item) {
      try {
        let response = await this.$bvModal.msgBoxConfirm(`¿Deseas eliminar la campaña ${item.name}?`, {
          title: 'Eliminar reporte',
          okVariant: 'danger',
          okTitle: 'Eliminar',
          cancelTitle: 'Cancelar',
        })
        if (response) {
          this.deleteReport(item)
        }
      } catch (e) {
        console.error(e.message);
      }
    },
    deleteReport (item) {
      item.loading = true

      this['broadcast/destroy']({
        campaign_id: item._id,
        callback: res => {
          item.loading = false
          if (res.error) return this.$message.error(res.error)

          this.$message.success('Listo, campaña eliminada')
          this.getRunningCampaigns(true)
        }
      })
    },
    getChatbots () {
      this['platform/get']({
        account_id: this.$route.params.account_id,
        platform_id: this.platform,
        callback: async (res) => {
          if (res.error) return this.$message.error(res.error)

          if(res.resource.length) {
            const {waba_id, model_id} = res.resource[0]
            this.modelId = model_id
            /*if(this.platformIsWhatsappOfficial) {
              this.getWhatsAppTemplates(waba_id)
            }*/
          }
        }
      })
    },
    getWhatsAppTemplates (waba_id) {
      this.resetTemplate()

      this['message_template/all']({
        waba_id,
        params: {
          limit: 500,
          account_id: this.$route.params.account_id,
        },
        callback: res => {
          if (res.error) return this.$message.error(res.error)
        }
      })
    },
    getFlows () {
      this['flow/all']({
        account_id: this.$route.params.account_id,
        callback: res => {
          if (res.error) this.$message.error(res.error)
        }
      })
    },
    renderTemplate(){
      const { templateName, selectedTemplate } = this
      if(selectedTemplate && selectedTemplate.name === templateName) return

      this.selectedTemplate = this.message_templates.find(el => el.name === templateName)
      const template = new RenderTemplate(this.selectedTemplate)

      this.header_example_text = ''
      this.header_example_file = null
      this.body_example = []
      this.messageTemplate = template.renderBody()
      this.header = template.renderHeader()
      this.buttons = template.renderButtons()
      this.footer = template.renderFooter()
    },
    resetTemplate () {
      this.templateName = this.selectedTemplate = this.blockId = null
      RenderTemplate.defaultView(this)
    },
    validateState (value) {      
      if(value) return null
      return this.missingData ? false : null
    },
    async sendBroadcast (users) {
      this.sendingBroadcast = true

      const params = await this.getBroadcastParams()
      if(!params) return this.sendingBroadcast = false

      this['broadcast/send']({
        users,
        ...params,
        callback: res => {
          this.sendingBroadcast = false
          if (res.error) return this.$message.error(res.error)
          this.$message.success('Mensajes enviados')
          const source = params.block_id ? 'Block' : 'Whatsapp Template'
          this.saveMixpanel(`Campaigns: Send ${source}`)
          this.getRunningCampaigns()
        }
      })
    },
    async sendBroadcastFromFile () {
      this.sendingBroadcast = true

      const params = await this.getBroadcastParams(['broadcastName' , 'usersFile'])
      if(!params) return this.sendingBroadcast = false

      let action = 'sendFromFile'
      let message = 'Mensaje enviado'
      let event = 'from File'

      if(this.scheduleDate && this.scheduleDate.startDate) {
        action = 'schedule'
        message = 'Mensaje programado'
        event = 'Scheduled'
        params.date = this.$moment(this.scheduleDate.startDate).format("YYYY-MM-DD HH:mm")
      }

      const url = await this.getFileUrl(this.usersFile)      
      if (!url) return this.sendingBroadcast = false
      this.usersUrlFile = url

      this[`broadcast/${action}`]({
        ...params,
        file_url: this.usersUrlFile,
        name: this.broadcastName,
        callback: res => {
          this.sendingBroadcast = false
          if (res.error) return this.$message.error(res.error)
          this.$message.success(message)
          const source = params.block_id ? 'Block' : 'Whatsapp Template'
          this.saveMixpanel(`Campaigns: Send ${source} ${event}`)
          this.getRunningCampaigns()
        }
      })
    },
    getBroadcastParams(extra) {
      return new Promise(async resolve => {
        const error = 'Error con la información del mensaje'
        try {

          const params = {
            account_id: this.$route.params.account_id,
            platform: this.platform,
            model_id: this.modelId
          }
          
          if(this.tabIndex < 1 && this.platform.indexOf('whatsapp') > -1) {
            this.missingData = this.validateData(extra)
            if(this.missingData) {
              this.$message.warning('Completa los datos requeridos')
              return resolve(false)
            }

            const templateParams = {
              template_name: this.templateName,
              header_example_text: this.header_example_text,
              body_example: this.body_example,
              message_template: this.messageTemplate,
            }

            if(this.header_example_file && typeof this.header_example_file != 'string') {
              const headerFile = await this.getFileUrl(this.header_example_file)
              if(!headerFile) {
                this.$message.error(error)
                return resolve(false)
              }
              templateParams.header_example_file = headerFile
            }

            return resolve({...params, ...templateParams})
          } else {
            if(!this.blockId) return this.missingData = true
          }

          const {blockId:block_id} = this
          return resolve({...params, block_id})
        } catch (e){
          console.log(e)
          this.$message.error(error)
          return resolve(false)
        }
      })
    },
    validateData (extra = []) {
      this.missingData = false

      if(!this.sourceSelected) return true

      for (let i = 0; i < this.bodyVars.length; i++) {
        if(!this.body_example[i]) return true
      }

      for (const value of extra) {
        if(!this[value]) return true
      }

      if(this.header.format) {
        return this.header.format === 'TEXT' ?
            this.headerVar && !this.header_example_text
            : !this.header_example_file
      }

      return false
    },
    getFileUrl(file) {
      return new Promise(async resolve => {
        const error = 'Error subiendo archivo'
        try {
          this.uploading = true
          const url = await UploadFile.call(this, file)
          this.uploading = false
          if(!url) {
            this.$message.error(error)
            return resolve(false)
          }
          return resolve (url)
        } catch (e) {
          console.log(e)
          this.$message.error(error)
          this.uploading = false
          return resolve(false)
        }
      })
    },
    async openBlock() {
      if(!this.flow) return

      const route = this.$router.resolve({
        name: 'Block',
        params: { flow_id: this.flow.id, block_id: this.blockId }
      })
      window.open(route.href, '_blank')
    },
    saveMixpanel (event) {
      const {email, admin_id, role_id} = this.getCurrentUser()
      mixpanel.track(event, {
        account_id: this.$route.params.account_id,
        unique_id: email,
        admin_id,
        role_id
      });
    },
    getRunningCampaigns (refresh = false) {
      this.refreshing = true

      this['broadcast/campaigns']({
        account_id: this.$route.params.account_id,
        refreshing: refresh,
        params: { status: 'running,scheduled' },
        callback: res => {
          this.refreshing = false
          if (res.error) return this.$message.error(res.error)
          if(refresh && !res.resource.length) this.$message.success('Se completó el envío de todas las campañas ')
        }
      })
    },
    recoverCampaign (item) {
      item.loading = true

      this['broadcast/recovery']({
        campaign_id: item._id,
        callback: res => {
          item.loading = false
          if (res.error) return this.$message.error(res.error)
          Download(
              res.data,
              `campaña_enviada.csv`,
              res.headers['content-type']
          )
        }
      })
    }
  },
  mounted () {
    this.getPlatforms()
    this.getFlows()
    this.getRunningCampaigns()
  },
  watch: {
    platform () {
      this.modelId = null
      this.getChatbots()
    },
    modelId (val) {
      if(this.platformIsWhatsappOfficial) {
        const chatbot = this.chatbots.find(el => el.model_id === val)
        if(chatbot) {
          this.getWhatsAppTemplates(chatbot.waba_id)
        }
      }
    }
  },
  components: {BroadcastUsers, MessageTemplatePreview, PlatformsRounded, 'k-select': Select }
}
</script>

<style lang="scss">
  .overflow-visible {
    overflow: visible;
  }
  .info-item {
    position: relative;
    padding-left: 3.5rem;
    margin-bottom: 0.3rem;
    margin-left: 1rem;

    &:not(:last-child) {
      border-left: 2px solid var(--primary);
      padding-bottom: 1.5rem;
    }

    .side-icon {
      position:absolute;
      left:-2rem;
      top: 0;
    }
  }

  #users-file {
    .custom-file-label {
      border-style: dashed;
      height: auto;
      margin: 0;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
    }
  }

  .custom-file-label:after {
    display: none !important;
  }

  @media (min-width: 768px) {
    .w-md-50 {
      max-width: 50%;
    }
  }

</style>
